import { StorageKeys } from "@/common/constants/storageKeys";
import { TenantDeploymentDTO } from "@/repository/models";
import { Client, Controller, mapUrl } from "@/repository";
import { envVariable, Variable } from "@/common/constants/envVariable";

export const deploymentsQueryKey = "deployments";

export const fetchDeploymentsFn = (): Promise<TenantDeploymentDTO[]> => {
	const tenantId = localStorage.getItem(StorageKeys.TIDForAzure) || "";
	const url = mapUrl(Controller.Deployments);

	return Client.instance.get<TenantDeploymentDTO[]>(url, {
		azureTenantId: tenantId,
	});
};

export const fetchDeploymentsApacFn = (): Promise<TenantDeploymentDTO[]> => {
	const baseUrl = envVariable(Variable.GatewayApiUrl);

	if (baseUrl && baseUrl.includes("emea")) {
		const tenantId = localStorage.getItem(StorageKeys.TIDForAzure) || "";
		const url = mapUrl(Controller.Deployments);

		return Client.instance.getApac<TenantDeploymentDTO[]>(url, {
			azureTenantId: tenantId,
		});
	} else {
		return fetchDeploymentsFn();
	}
};
